import styled from 'styled-components';
import {UnderlinedListWithSpan} from '../../atoms/ListItem/index';
import Checkbox from '../../atoms/Checkbox/index';
import {TrashIcon} from '../../atoms/Icons';
import { Grey500,Grey50,ColorDefs,OnSurface,DividerColor } from '../../Colors';

export default {
	Li : styled.li`
        display: flex;
        flex-direction: row;
		align-items: center; 
		justify-content:flex-start;
	`,
	Index : styled.div`
		margin-right : 1rem;
		padding-right : 1rem;
		color : ${Grey500};
		border-right : solid 1px ${DividerColor};
	`,
	AnswerStyle : styled.span`
		border: 1px dotted ${DividerColor};
		border-radius: 1em;	
	`,
	AnswerTextStyle : styled.span`
		visibility:hidden;
	`,
	UnderlinedList : styled(UnderlinedListWithSpan)`
		color : ${({checked}) => checked ? OnSurface : Grey500};
		white-space: nowrap;
		overflow:hidden;
		text-overflow: ellipsis;
		padding-top : 5px;
	`,
	Checkbox : styled(Checkbox).attrs({
		color : ColorDefs.primary
	})`
		margin-right : 1rem;
	`,
	TrashIconWrapper : styled.div`
		color : ${Grey500};
		margin-left : 1rem;
	`,
	SampleIcon : styled.div`
		display : inline-block;
		border-radius: 2px;	
		padding : 0 0.5rem 0 0.5rem;
		background-color : ${Grey50};
		color : ${Grey500};
		vertical-align : middle;
		margin-right : 0.5rem;
	`,
	TrashIcon
};